import * as React from "react";

function SackDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M276.1 230.3c6.6 1.2 16.6 3.2 21 4.4 10.7 2.8 17.1 13.8 14.2 24.4-2.8 10.7-13.8 17.1-24.4 14.2-3.9-1-17.4-3.6-21.8-5.2-12.2-1-23 .6-28.6 3.5-6.3 2.8-7.8 6.1-8.2 8.1-.6 3.4 0 4.6.2 5 .2.5 1 1.7 3.6 3.5 6.1 4.2 15.7 7.2 29 11.5l1.7.2c12.1 3.7 28.3 8.5 40.4 17.4 6.7 4.8 13 11.4 16.9 20.4 4 9.1 4.8 19.1 3 29.5-3.3 19-15.9 32-31.7 38.7-4.8 1.2-10 3.6-15.3 4.6v5.5c0 11.1-9 20.1-21 20.1-10.2 0-19.2-9-19.2-20.1v-6.4c-9.5-2.2-22.8-6.4-29.8-9.1-1.7-.6-3.2-1.1-4.4-2.4-10.5-2.6-16.2-13.9-12.7-24.4 3.5-10.5 14.8-16.2 25.3-12.7 2 .7 4.2 1.4 6.4 2.2 9.5 3.2 20.2 6.8 26.2 7.8 12.8 2 22.7.7 28.8-1.9 5.5-2.3 7.4-5.3 8-8.8.7-4 .1-5.8-.3-6.6-.3-.9-1.2-2.3-3.7-4.1-5.9-4.3-15.3-7.4-29.3-11.7l-2.2-.6c-11.7-3.5-27-8.1-38.6-16-6.6-4.5-13.1-10.7-17.3-19.5-4.2-8.9-5.2-18.8-3.4-29 3.2-18.3 16.2-30.9 31.1-37.7 4.1-2.2 10.3-3.9 15.9-5.1v-6.9c0-10.2 9-19.2 20.1-19.2 11.1 0 20.1 9 20.1 19.2v7.2zM179 120.4l-57.1-82.78C110.1 21.7 122.4 0 141.7 0h228.6c19.3 0 30.7 21.7 19.8 37.62l-58 82.78c9.1 5.3 18.7 11.7 29.1 19.5C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96H96c-53.02 0-96-43-96-96 0-141.2 89.41-230.5 150.8-276.1 10.4-7.8 20-14.2 28.2-19.5zm25.9 40.4C150.9 195.4 48 277 48 416c0 26.5 21.49 48 48 48h320c26.5 0 48-21.5 48-48 0-139-102.9-220.6-156.9-255.2l-13.8-9.7h-74.6l-13.8 9.7zm80.2-57.7 39.5-56H187.4l38.6 56h59.1z"
  }));
}

const ForwardRef = React.forwardRef(SackDollarIcon);
export default ForwardRef;